export default __webpack_public_path__ + "static/media/013.cb5ea65f.jpg";